// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oBo2","type":"styles_type__3Ca-L","choices":"styles_choices__RxQIr"};